/**
 * 包括契約検索API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 契約者情報
 */
export interface Sgkb702aRequestLoginInfoDto {
    /**
     * 担当部署：数字
     */
    loginBusho?: string;
    /**
     * 担当者：英数字
     */
    loginTntsh?: string;
}

